$('#fastProductEntryList').on('DOMSubtreeModified', function (e, b, c) {
    if (e.target.nodeName == 'FORM') {

        var context = $(this);
        var container = $('.is-cart-item:last', context);
        var html = $('.product_container_replace', container).html();
        $('.product_quantity_container', container).html(html);

        if ($('.is-cart-item', context).length > 0) {
            $('#addProductsToCart_Syskomp').removeAttr('disabled');
        } else {
            $('#addProductsToCart_Syskomp').attr('disabled', 'disabled');
        }
    }
});


$('#addProductsToCart_Syskomp').on('click', function () {
    const formData = new FormData();
    $('.quantity.syskomp_quantity > div > input.syskomp-number-input__input').each(function () {
        formData.set($(this).attr('name'), $(this).val());
    });

    window.axios.post(window.config.urls.pushProducts, formData).then(({data: data}) => {
        if (data.success) {

            $('#fpeAddToCardModal').modal('show');
            $('#fpeAddToCardModal').find('.is-fpe-modal-multi-text--count').text(data.success.length);
            if (data.success.length === 1) {
                $('.is-fpe-modal-single-text').show();
                $('.is-fpe-modal-multi-text').hide();
            }
            if (data.success.length > 1) {
                $('.is-fpe-modal-multi-text').show();
                $('.is-fpe-modal-single-text').hide();
            }
        }
    });
});

